import { registerLocaleData } from '@angular/common';
import { Injectable, Injector, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { InjectorProvider } from '@shared/providers';
import { getPreferredLanguage, importAngularLocale } from '@shared/utils';
import { CheckForUpdateService } from './check-for-update.service';

@Injectable({
  providedIn: 'root'
})
export class AppInitializeService {
  private readonly translateService = inject(TranslateService);
  private readonly updateService = inject(CheckForUpdateService);

  private readonly allowedLanguages = ['en', 'de'];

  constructor() {
    InjectorProvider.injector = inject(Injector);
  }

  async init(): Promise<boolean> {
    const language = getPreferredLanguage();

    this.updateService.init();

    this.translateService.addLangs(this.allowedLanguages);
    this.translateService.setFallbackLang(language);

    const locale = await importAngularLocale(language);
    registerLocaleData(locale.default);

    return true;
  }
}
